import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderState } from '@app/models/loader';
import { LoaderService } from '@app/services/loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnDestroy {
  show = false;
  private subscription: Subscription;
  constructor(private loaderService: LoaderService) { }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  AfterViewInit() {
    this.subscription = this.loaderService.loaderState
    .subscribe((state: LoaderState) => {
      this.show = state.show;
    });
  }
}
